import { AppointmentDataService } from './../data-services/appointment-data.service';
import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { CreateAppointmentViewModel } from '../business-entities/create-appointment-view-model.interface';
import { ClientAppLogout } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Injectable({ providedIn: 'root' })
export class AppointmentService {
    constructor(private adService: AppointmentDataService) { }

    CreateAppointment(model: CreateAppointmentViewModel): Promise<GenericResponse<any>> {
        return this.adService.CreateAppointment(model);
    }
    VerifyOTP(model: any): Promise<GenericResponse<any>> {
        return this.adService.VerifyOTP(model);
    }
    ValidateMobileOtp(model: any): Promise<GenericResponse<any>> {
        ClientAppLogout();
        return this.adService.ValidateMobileOtp(model);
    }
}